import * as React from "react"
import "./Footer.scss";
import { useTranslation } from "react-i18next";

const Footer = (props: any) => {
    const [t, i18n] = useTranslation();


    const legalLink = () => {
        switch (i18n.language) {
            case 'de':
                return 'https://start.docuware.com/de/legal';
            
            default:
                return 'https://start.docuware.com/legal';
        }
    }

    const disclaimerLink = () => {
        switch (i18n.language) {
            case 'de':
                return 'https://start.docuware.com/de/disclaimer';

            default:
                return 'https://start.docuware.com/disclaimer';
        }
    }

    const dataPrivacyLink = () => {
        switch (i18n.language) {
            case 'de':
                return 'https://start.docuware.com/de/data-protection';

            case 'es':
                return 'https://start.docuware.com/es/declaracion-privacidad';

            case 'fr':
                return 'https://start.docuware.com/fr/declaration-confidentialite';

            default:
                return 'https://start.docuware.com/data-privacy';
        }
    }

    const officeLocationLink = () => {
        switch (i18n.language) {
            case 'de':
                return 'https://start.docuware.com/de/office-locations';

            case 'es':
                return 'https://start.docuware.com/es/office-locations';

            case 'fr':
                return 'https://start.docuware.com/fr/tous-les-bureaux';

            default:
                return 'https://start.docuware.com/office-locations';
        }
    }


    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="footer-links">
                            <article>
                                <h4 className="footer-subhead">{t("Legal")}</h4>
                                <ul className="footer-nav">
                                    <li><a href={legalLink()} target="_blank">{t("General Business Terms")}</a></li>
                                    <li><a href={disclaimerLink()} target="_blank">{t("Privacy Policy/Disclaimer")}</a></li>
                                    <li><a href={dataPrivacyLink()} target="_blank">{t("Data Privacy")}</a></li>
                                </ul>
                            </article>
                        </div>
                        <div className="col-sm-6">

                        </div>
                    </div >
                    <div className="col-md-3 col-sm-4">
                        <p>DocuWare Corporation</p>
                        <p className="location">
                            25 Creek Drive, Suite 100 <br />
                        Beacon, NY 12508 <br />
                        United States
                    </p>
                        <p className="location">
                            <span className="label">Tel:</span>+1 (845)563-9045<br />
                            <span className="label">Toll-free:</span>+1 (888)565-5907<br/>
                            <span className="label">Fax:</span>+1 (888)563-9046
                    </p>
                    </div>
                    <div className="col-md-3 col-sm-4">
                        <p>DocuWare Europe GmbH</p>
                        <p className="location">
                            Planegger Str. 1<br />
                        82110 Germering <br />
                        Germany
                    </p>
                        <p className="location">
                            <span className="label">Tel:</span>+49 89 894433-0<br />
                            <span className="label">Fax:</span>+49 89 8419966
                    </p>
                    </div>
                    <div className="col-md-6">

                    </div>

                </div >
                <div className="row">
                    <div className="col-md-6">
                        <p className="copyright">&copy; 2021 DocuWare Corporation</p>
                    </div>
                    <div className="col-md-3 col-sm-4">
                        <p className="copyright"><a href={officeLocationLink()} target="_blank">{t("View all locations")}</a></p>
                    </div>
                    <div className="col-md-3 col-sm-4">

                    </div>
                </div >
            </div >
        </footer>
    );
}

export default Footer;